import { render, staticRenderFns } from "./StructureWebpackFields.vue?vue&type=template&id=20b3ad4a&scoped=true&"
import script from "./StructureWebpackFields.vue?vue&type=script&lang=ts&"
export * from "./StructureWebpackFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3ad4a",
  null
  
)

export default component.exports